<template>
  <section>
    <div class="custom-star" title="star level">
      <a @click="onClick">
        <i
          class="fas fa-star"
          :class="{
            'star-level-0': starLevel === 0,
            'star-level-1': starLevel === 1,
          }"
        ></i>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: 'star',
  props: {
    level: {
      type: [Number, String],
      default: 0,
    },
    id: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    starLevel() {
      let _level = 0
      if (this.level) {
        _level = parseInt(this.level)
      }
      return _level
    },
  },
  methods: {
    onClick() {
      let data = {
        id: this.id,
        level: this.starLevel,
      }
      this.$emit('clicked', data)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-star {
  padding: 5px;
  a {
    text-decoration: none;
    cursor: pointer;
  }
  a:hover {
    outline: none;
    text-decoration: none;
    color: #72afd2;
    text-shadow: 0 0 3px #0026ff;
  }
}
.star-level-0 {
  color: #b4b4b4;
  font-size: 1.2em;
}
.star-level-1 {
  color: #f4c304;
  font-size: 1.2em;
}
</style>
